import axios, { Canceler } from 'axios'
import {
  IProductsRespDto,
  IProductCreateDto,
  IProductByIdRespDto,
  IProductUpdateDto,
  IProductsAllRespDto,
  IUpdateProductQrLinkDto,
  IUpdateProductSatelliteDto,
  IProductQrLinkRespDto,
  IUpdateProductPublicStatusDto,
} from 'src/types/product.type'
import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { ICancelRemovalDto, IMessageResponseDto } from 'src/types'

class ProductDataService extends EnhancedWithAuthHttpService {
  CancelToken
  productsCancel?: Canceler
  productsAllCancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }
  createProduct(dto: IProductCreateDto) {
    return this.post<IMessageResponseDto, IProductCreateDto>(`products`, dto)
  }

  async getProductById(id: string, locale: string) {
    return await this.get<IProductByIdRespDto>(`products/${id}/${locale}`)
  }

  async editProduct(dto: IProductUpdateDto, id: string) {
    return await this.put<IMessageResponseDto, IProductUpdateDto>(`products/${id}`, dto)
  }

  removeProducts(ids: string[]) {
    return this.delete<string>(`products`, { data: { ids } })
  }

  cancelRemove(params: ICancelRemovalDto) {
    return this.get<IMessageResponseDto>('products/cancel-deletion', { params })
  }

  getProducts(params?: {}) {
    return this.get<IProductsRespDto>(`products`, { params })
  }

  getAllProducts(params?: {}) {
    if (this.productsAllCancel) {
      this.productsAllCancel()
    }

    return this.get<IProductsAllRespDto>(`products/all`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.productsAllCancel = c
      }),
    })
  }

  getFilteredProducts(params?: {}) {
    if (this.productsCancel) {
      this.productsCancel()
    }

    return this.get<IProductsRespDto>(`products`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.productsCancel = c
      }),
    })
  }

  remintProductToken(id: string) {
    return this.post<IMessageResponseDto, null>(`products/${id}/token`, null)
  }

  updateProductSatellite(id: string, dto: IUpdateProductSatelliteDto) {
    return this.put<IMessageResponseDto, IUpdateProductSatelliteDto>(
      `products/${id}/satellite`,
      dto,
    )
  }

  updateProductPublicStatus(id: string, dto: IUpdateProductPublicStatusDto) {
    return this.put<IMessageResponseDto, IUpdateProductPublicStatusDto>(
      `products/${id}/public`,
      dto,
    )
  }

  updateProductTokenURI(id: string) {
    return this.put<IMessageResponseDto, null>(`products/${id}/token-uri`, null)
  }

  getOverrideUrl(productId: string, lngCode: string) {
    return this.get<IProductQrLinkRespDto>(`products/${productId}/urls/${lngCode}`)
  }

  updateQrLink(dto: IUpdateProductQrLinkDto) {
    return this.put<IMessageResponseDto, Omit<IUpdateProductQrLinkDto, 'id'>>(
      `products/${dto.id}/urls`,
      { overrideUrl: dto.overrideUrl, code: dto.code },
    )
  }

  checkCodeExist(code: string, id?: string, accountId?: string) {
    return this.get<IMessageResponseDto>(`products/code/${code}`, {
      params: { accountId, id },
    })
  }

  getInitialCode(accountId: string) {
    return this.get<string>(`products/code/initial`, { params: { accountId } })
  }

  updateProductNfts() {
    return this.put<IMessageResponseDto, any>(`crone-jobs/update-product-nfts`, {})
  }
}

const ProductService = new ProductDataService()
export default ProductService
